import { Route } from 'routes/types/types';

export const isRouteVisibleToUser = (route: Route, isAdmin: boolean) =>
  !route.adminOnly || isAdmin;

export const filterRoutesByAdminAccess = (
  routes: Route[],
  isAdmin: boolean
): Route[] =>
  routes
    .filter(route => isRouteVisibleToUser(route, isAdmin))
    .map(route => ({
      ...route,
      pages: route.pages
        ? filterRoutesByAdminAccess(route.pages, isAdmin)
        : route.pages
    }));
